// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { ReturnOrder, returnOrderSchema } from '@/return-order/api/types';
import { z } from 'zod';

const getReturnOrderResponseSchema = z.object({
  data: returnOrderSchema,
  metadata: responseMetadataSchema,
});

/**
 * Fetches a single return order by its key.
 */
export async function getReturnOrder(
  returnOrderKey: string
): Promise<ReturnOrder> {
  const url = `/v1/return-order/${returnOrderKey}`;
  const response = await api.get(url);

  const { data } = await parseResponse(
    getReturnOrderResponseSchema,
    response.data,
    {
      schemaName: 'GetReturnOrder',
      endpoint: url,
    }
  );
  return data;
}
